import { render, staticRenderFns } from "./extra-content.vue?vue&type=template&id=8c88c9fa&lang=pug&"
import script from "./extra-content.vue?vue&type=script&lang=js&"
export * from "./extra-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports